import type { GridApi, SelectionChangedEvent } from 'ag-grid-community';

export enum ScreenMode {
  VIEWING_MODE = 'VIEWING_MODE',
  SELECTING_MODE = 'SELECTING_MODE',
}

export enum Tab {
  RATES_FIELD = 'RATES_FIELD',
  RATES_FIXING = 'RATES_FIXING',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
}

export interface MappingAuditState {
  screenMode: ScreenMode;
  loadedTabs: Tab[];
  selectedRows: { [key in Tab]: {} };
  loading: boolean;
  activeTab: Tab;
  errorMessage: string | null;
  successMessage: string | null;
}

export type BqTimestamp = string;
export type OperationType = string;

export interface RatesFieldAuditTrailRow {
  ID: string;
  GROUP_ID: string;
  FIELD_NAME: string;
  INPUT_VALUE: string;
  MAPPED_VALUE: string;
  VALID_FROM?: BqTimestamp | null;
  VALID_TO?: BqTimestamp | null;
  UPDATED_BY?: string | null;
  UPDATE_TIMESTAMP?: BqTimestamp | null;
  OPERATION_TYPE: OperationType;
}

export interface RatesFixingAuditTrailRow {
  ID: string;
  GROUP_ID: string;
  INPUT_REFERENCE_INDEX: string;
  MAPPED_REFERENCE_INDEX: string;
  MAPPED_PAY_FREQUENCY?: string | null;
  MAPPED_DAY_COUNT?: string | null;
  VALID_FROM?: BqTimestamp | null;
  VALID_TO?: BqTimestamp | null;
  UPDATED_BY?: string | null;
  UPDATE_TIMESTAMP?: BqTimestamp | null;
  OPERATION_TYPE: OperationType;
}

export interface LegalEntityAuditTrailRow {
  ID: string;
  LEGAL_ENTITY: string;
  MAPPED_GROUP_ID: string;
  VALID_FROM?: BqTimestamp | null;
  VALID_TO?: BqTimestamp | null;
}

export interface AuditTrailsGrouped {
  ratesField: RatesFieldAuditTrailRow[];
  ratesFixing: RatesFixingAuditTrailRow[];
  legalEntity: LegalEntityAuditTrailRow[];
}

export interface RatesFixingRow {
  id: string;
  fixingDate: string;
  oldRate: number;
  newRate: number;
  timestamp: string;
}

export interface AuditGridProps {
  rowData?: any[];
  isLoading?: boolean;
  tab: Tab;
  screenMode: ScreenMode;
  onGridReady?: (api: GridApi) => void;
  onSelectionChanged?: (event: SelectionChangedEvent) => void;
  /** Called when filter changes (e.g. to refresh displayed selection count). Only used in selecting mode. */
  onFilterChanged?: (api: GridApi) => void;
}
